import React, { FC } from "react";
import tw, { TArg as TArgument } from "../../tailwindcss-classnames";
import { Button } from "../button/button";
import { Errors } from "../form/errors";
import { useStandardForm } from "../form/use-standard-form";
import { B1 } from "../type/Typography";
import { useFocusFirstChildInput } from "lib/useFocusFirstChildInput";
export type ForgotPasswordFormData = {
  email: string;
};

const defaultValues: ForgotPasswordFormData = {
  email: "",
};
const inputs = ["email"] as const;

export const ForgotPasswordPageComponent: FC<{
  isLoading: boolean;
  onSubmit: (data: ForgotPasswordFormData) => Promise<void>;
  error: any;
  successMsg: string;
}> = ({ onSubmit, error, successMsg }) => {
  const reference = useFocusFirstChildInput();
  const { form, getInput, submitButton } = useStandardForm(
    null,
    defaultValues,
    "forgotpassword"
  );

  return (
    <div
      className={tw(
        "max-w-screen-container-large",
        "mx-auto",
        "p-16",
        "space-y-16"
      )}
      ref={reference}
    >
      <B1>
        Please enter your email address. We will send you an email with
        instructions, but please check your junk mail folder if you don't see
        it.
      </B1>
      <form onSubmit={form.handleSubmit(onSubmit)} className={tw("space-y-16")}>
        {inputs.map((it) => getInput(it, { key: it }))}
        <Errors errors={error} />
        <div className={tw("space-y-16")}>
          {submitButton("Send Email")}

          {successMsg && <B1 className="text-gold">{successMsg}</B1>}

          <hr className={tw("border-unassumingGray" as TArgument, "block")} />

          <Button href={"/login"} color="sand">
            Back to Login
          </Button>
        </div>
      </form>
    </div>
  );
};
